<!-- 删除授权月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KNTYVWC",
                "ticketNo": "粤TEST01",
                "deleteAuthCarCodes": "粤Y12345,粤Y12346",
                "deleteMode": 1,
                "billCode": "wdl0001",
                "remark": "授权月票",
                "operator": "admin123",
                "operateTime": "2017-11-07 00:00:00",
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台为某张月卡绑定的车牌删除授权",
                t_url: this.commonUrls.test+"delAuthMonthCard",
                p_url: this.commonUrls.prod+"delAuthMonthCard",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'ticketNo', info2: '是', info3: 'String', info4: '月卡唯一编号' },
                        { info1: 'deleteAuthCarCodes', info2: '是', info3: 'String', info4: '要删除的授权车牌号数组。车牌之间英文字母的逗号分隔,且不能重复' },
                        { info1: 'deleteMode', info2: '是', info3: 'Integer', info4: '删除授权模式, 0车主删除 1系统自动删除' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '操作流水号。单次操作的流水号必须得唯一,用于防重' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'operator', info2: '是', info3: 'String', info4: '操作员' },
                        { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间，yyyy-MM-dd HH:mm:ss' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/vip/delAuthMonthCard.vue